import * as NativeAxios from 'axios';
import React from 'react';
import * as ReactRedux from 'react-redux';
import * as store from 'store';

import {axios, checkVisible, venditshop} from '../../index';
import {receiveLoadingUpdate, updateShoppingCart} from '../../redux/actions';
import P2 from '../structure/helper/P2';
import P3 from '../structure/helper/P3';
import P4 from '../structure/helper/P4';
import ProductInput from './ProductInput';

class Product extends React.PureComponent {
    constructor(props) {
        super(props);
        this.ref = React.createRef();

        this.input_ref = React.createRef();


        let bestellbar = props.bestellbar;


        //hier muss der separator abgefragt werden

        if(!!this.props?.hausmesse || !!this.props?.vertriebsaktion){
            bestellbar = (!!this.props?.hausmesse || !!this.props?.vertriebsaktion);
        }else if((!props?.bestellartikel && props?.bestand3 <= 0 && props?.meta?.conf?.bestand0nichtbestellen)){
            bestellbar = false;
        }
        if((!props?.bestellartikel && this.props?.abwlager>1 && this.props?.abwbestand<= 0 && props?.meta?.licenseCache?.multilager )){
            bestellbar = false;
        }


        this.state = {
            preisBeiAnbruch: null,
            visible: false,
            loaded: false,
            preise: props.preise || null,
            // bestellbar: (!!this.props?.hausmesse || !!this.props?.vertriebsaktion)
            //     || (!(!props?.bestellartikel && props?.bestand3 <= 0 && props?.meta?.conf?.bestand0nichtbestellen)
            //         ? props.bestellbar || false
            //         : false),
            bestellbar: bestellbar,
            vkpAnzeigen: !!(props?.meta?.vkpAnzeigen || (props?.meta?.aktionspreiseAnzeigen && props?.forcePromotion)),
            onlyKvpAnzeigen: !!(props?.meta?.onlyKvpAnzeigen),
            onlyKvpAnzeigenBoersen: !!(props?.meta?.conf?.showOnlyKVPBoersen)
        };

        this.amPreiseLaden = false;

        this.onVisibilityChange = (visible) => {
           // console.log('onVisibilityChange');
            if (visible && !this.state.visible) {
                this.setState({visible: true}, () => {
                    if (!this.state.preise) {
                        // console.log('loadPreise');
                        this.loadPreise();
                    }

                    if (!this.state.preisBeiAnbruch && this.props?.anbruch_aufschlag_kz &&
                        this.props?.meta?.licenseCache?.aufpreisBeiAnbruch && this.props?.meta.login
                        && this.props?.gebindeeinheit && this.props?.gebindeeinheit != this.props?.verkaufseinheit
                    ) {
                        this.loadPreiseBeiAnbruch(this.props.gebindeeinheit);
                    }
                });
            }
        };

        this.cancelToken = null;


        this.loadPreiseBeiAnbruch = async (gebindeEinheit) => {
            if (this.props?.artikel) {
                let p = null;
                p = axios.get((this.props?.meta?.conf?.cssCompletePath
                        ? this.props?.meta?.hostname
                        : '') + '/price/' + (this.props?.hausmesse ? 'messe/' + this.props?.hausmesse + '/' : '') + (this.props?.vertriebsaktion ? 'vertriebsaktion/' + this.props?.vertriebsaktion + '/' : '') + 'anbruch/artikel/' + this.props.artikel + '/' +
                    (this.props.preisnummer || 0) + '/1/' + gebindeEinheit + '/');
                if (p) {
                    try {
                        const {data} = await p;
                        this.setState({preisBeiAnbruch: data});
                    } catch (e) {

                    }
                }
            }
        };


        this.loadPreise = async (neue_menge) => {
            if (this.amPreiseLaden) {
                return;
            }
            this.amPreiseLaden = true;
            let menge = neue_menge != null ? neue_menge : this.props.menge;

            if(menge <0){
                menge=1;
            }

            if (this.props.preise) {
                // Preise sind durch die Props gesetzt und müssen nicht nachgeladen werden
                this.setState({loaded: true});
            } else if (!this.state.preise || !this.props.mcboerse) {
                const CancelToken = NativeAxios.CancelToken;
                const source = CancelToken.source();
                this.cancelToken = source;
                // Keine Preise im State, es sollen aber welche angezeigt werden > reload
                let p = null;
                //mcboerse in der Produktkachel brauchen wir erstmal keinen Preis
                if (this.props.artikel) {
                    //let einheit = this.props?.gebindeeinheit || this.props?.verkaufseinheit;
                    let einheit = this.props?.verkaufseinheit;

                    p = axios.get((this.props?.meta?.conf?.cssCompletePath
                            ? this.props?.meta?.hostname
                            : '') + '/price/' + (this.props?.hausmesse ? 'messe/' + this.props?.hausmesse + '/' : '') + (this.props?.vertriebsaktion ? 'vertriebsaktion/' + this.props?.vertriebsaktion + '/' : '') + 'artikel/' + this.props.artikel + '/' +
                        (this.props.preisnummer || 0) + '/' +
                        (menge || 1) + '/' + einheit + '/' +
                        (this.props.forcePromotion ? '1/' : '0/'), {cancelToken: source.token});
                } else if (this.props.boerse) {
                    p = axios.get((this.props?.meta?.conf?.cssCompletePath
                        ? this.props?.meta?.hostname
                        : '') + '/price/' + (this.props?.hausmesse ? 'messe/' + this.props?.hausmesse + '/' : '') + (this.props?.vertriebsaktion ? 'vertriebsaktion/' + this.props?.vertriebsaktion + '/' : '') + 'boerse/' + this.props.boerse + '/' + (menge || 1) + '/1/', {
                        cancelToken: source.token,
                        'test': "test"
                    });
                }
                if (p) {
                    try {
                        const {data} = await p;

                        this.setState({preise: data, loaded: true});
                    } catch (e) {
                        if (NativeAxios.isCancel(e)) {
                            // nichts tun
                        }
                        // this.setState({preise: null, loaded: true, bestellbar: false});
                    }
                } else {
                    this.setState({preise: null, loaded: true, bestellbar: false});
                }
            } else {
                // Keine Preise gesetzt, es sollen auch keine geladen werden
                this.setState({loaded: true});
            }
            this.amPreiseLaden = false;
        };

        this.ichWurdeNachRechtsGeswiped = this.ichWurdeNachRechtsGeswiped.bind(this);
        this.ichWurdeNachLinksGeswiped = this.ichWurdeNachLinksGeswiped.bind(this);
    }

    static defaultProps = {hideImg: false};

    componentDidMount() {
        this.ref.current.onVisibilityChange = this.onVisibilityChange;
        checkVisible();
    }

    componentWillUnmount() {
        if (this.cancelToken) {
            this.cancelToken.cancel();
        }
    }

    ichWurdeNachRechtsGeswiped = async () => {
        let id;
        let produkttyp;
        const menge = this.input_ref.current.state.menge;
        if (this.props?.artikel) {
            id = this.props.artikel;
            produkttyp = 'a';
        } else if (this.props?.boerse) {
            id = this.props.boerse;
            produkttyp = 'b';
        } else if (this.props?.mcboerse) {
            id = this.props.mcboerse;
            produkttyp = 'm';
        }
        const t = await this.props.changeCart(produkttyp, id, menge, true, (this.props?.meta?.conf?.cssCompletePath
            ? props?.meta?.hostname
            : ''));
        return t;
    };

    ichWurdeNachLinksGeswiped = () => {
        this.input_ref.current?.removeFromCart();
    };

    render() {
        const mobile = this.props.mobile || false;
        const medium = this.props.medium || false;

        const props = this.props;

        let ordersatzspecialBezeichnung = (this?.props?.settings?.find((e) => e.bezeichnung == 'ordersatzspecialBezeichnung')?.wert || 'false') == 'true';
        let ordersatzspecialArtikel = (this?.props?.settings?.find((e) => e.bezeichnung == 'ordersatzspecialArtikel')?.wert || 'false') == 'true';

        const classes = ['_Product'];
        let id = null;
        let productType = null;
        const hints = [];
        let anzeigeNummer = null;
        let linkDetails = null;

        let preisnummer = 0;


        let hausmesse = this.props?.hausmesse;
        const meta = this.props.meta || {};
        const conf = meta.conf || {};
        const gebinde = this.props.meta?.licenseCache?.kommissionGebinde || false;
        //hier mal versuchen
        const fehlerBeimPreisLaden = conf.keinpreissperre &&
            (this.state.loaded && (!this.state.preise || !this.state?.preise?.vkp));


        let verkaufseinheit = null;
        if (conf.anzeigeEinheit && this.props.verkaufseinheit && this.props.gebindeeinheit &&
            this.props.verkaufseinheit !== this.props.gebindeeinheit && this.props.umpack) {
            /* const vk = this.props.verkaufseinheit.toString().toLowerCase();
            const klartext = vk.charAt(0).toUpperCase() + vk.substr(1); */
            const klartext = this.props.umpack;
            verkaufseinheit = <span className="verpackung">(Im Umpack {klartext})</span>;
            classes.push('hasVerkaufseinheit');
        }
        let artikelNummerText;
        if (this.props.artikel) {
            id = this.props.artikel;
            productType = 'a';
            artikelNummerText = 'Artikel: ' + id;
            anzeigeNummer = <h6 className="artikelnummer">Artikel: {id}{verkaufseinheit}</h6>;
            preisnummer = this.props.preisnummer || 0;
        } else if (this.props.boerse) {
            id = this.props.boerse;
            productType = 'b';
            artikelNummerText = 'Aktion: ' + id;
            anzeigeNummer = <h6 className="artikelnummer">Aktion: {id}</h6>;
        } else if (this.props.mcboerse) {
            id = this.props.mcboerse;
            productType = 'm';
            artikelNummerText = 'MC-Börse: ' + id;
            anzeigeNummer = <h6 className="artikelnummer">Mutiple Choice Aktion: {id}</h6>;
        }
        classes.push('hasArtikelnummer');

        let kampagneShopSpezialGrund = null;
        if (this.props.specialoffer) {
            const shop_spezial_grund = this.props.shop_spezial_grund || '';
            classes.push('isSpecialOffer');
            kampagneShopSpezialGrund = <P3 className="aktionsgrund">{shop_spezial_grund}</P3>;
        }

        let dontShow = productType == 'm';


        if (meta?.licenseCache?.showAllePreise) {
            classes.push('vkpAlternativ');
        }
        if (!fehlerBeimPreisLaden) {
            linkDetails = (this.props.hrefPrefix || '') + '/product/' + productType + '/' + id + '/' +
                venditshop.helper.stripStringForUrl(venditshop.helper.fix_euro_sign(this.props.bezeichnung)) + '/';
        }

        let bild;
        if (this.state.visible) {
            bild = (props?.meta?.conf?.cssCompletePath
                ? props?.meta?.hostname
                : '') + '/image/product/' + productType + '/' + id + '/1/' + preisnummer + '/120/600';
        } else {
            //Der sorgt für unnötigt viele Anfragen
            // bild = (props?.meta?.conf?.cssCompletePath ? props?.meta?.hostname : '') + '/image/product/a/0/1/0/1/1';
            bild ='';
        }

        if (!this.props.bestellbar && this.props?.meta?.customer?.gvl) {
            hints.push(
                <div key="top" className="hint-vororder" title="Voroder">
                    <i className="icon fas fa-minus-circle"/>Vororder
                </div>
            );
        }

        if (meta?.licenseCache?.boersendetails && this.props.boersen && this.props.boersen.length) {
            hints.push(
                <div key="partofboerse" className="hint-boerse"
                     title="Der Artikel ist derzeit Bestandteil eines Aktionspakets">
                    <i className="icon fas fa-gift"/>
                </div>
            );
            // cube, archive, box, box-open, gift
        }

        if (this.props.bestseller) {
            hints.push(
                <div key="top" className="hint-top" title="Bestseller">
                    <i className="icon fas fa-star"/>TOP
                </div>
            );
        }

        if (this.props.neuheit) {
            hints.push(
                <div key="new" className="hint-new" title="Neu im Sortiment">
                    <i className="icon fas fa-bolt"/>NEW
                </div>
            );
        }
        if (this.props.nur_gebinde && gebinde && this.props.picmenge_verkauf === 1 && !this?.props?.anbruch_zulassen
            && this.props.umpack != 1) {
            hints.push(
                <div key="gebinde" className="hint-top"
                     title={'Artikel wird in Mengen von je ' + this.props.umpack + ' verkauft.'}>
                    {this.props.umpack}ER
                </div>
            );
        }

        const display_bestellartikel = this.props.bestellartikel && (!conf.display_bestellartikel_login_only || meta.login);

        if (display_bestellartikel) {
            hints.push(
                <div key="bestellartikel" className="hint-bestellartikel"
                     title={this.props.bestellartikel_text || conf?.bestellartikeltext || 'Der Artikel ist derzeit nicht auf Lager und wird für Sie bestellt'}>
                    <i className="icon fas fa-truck"/>
                </div>
            );
        } else if (meta?.licenseCache?.bestandAnzeige && meta?.login && this?.props?.artikel) {

            let bestand = this.props?.bestand || 0;
            let hint;
            //Prüfen ob es sich um Convience oder Getränke sich handelt
            if (conf?.guNordLager2 && this?.props?.customer?.kundengruppe == 2
                && (this?.props?.config?.breadcrumbs[0]?.href_id == 26 || this?.props?.config?.breadcrumbs[0]?.href_id == 41)
            ) {
                bestand = this.props?.bestand2 || 0;
            }

            if (conf?.bestandallePreisnummern) {
                bestand = this.props?.bestand3 || 0;
            }

            if ( meta?.licenseCache?.multilager && this.props?.abwlager> 1
            ) {
                bestand = this.props?.abwbestand || 0;
            }

            if (meta?.licenseCache?.lagerbestandUeberschreiben && this.props?.bestand_ueberschreiben) {
                const lagerbestandUeberschreiben = this.props?.bestand_ueberschreiben;
                if (lagerbestandUeberschreiben == 3) {
                    hint = <div key="bestellartikel " className="hint-bestellartikel wenig"
                                title={conf?.bestandAnzeige?.gering}>
                        <i className="icon fas fa-truck"/>
                    </div>;
                } else if (lagerbestandUeberschreiben == 2) {
                    hint = <div key="bestellartikel " className="hint-bestellartikel gering"
                                title={conf?.bestandAnzeige?.ausreichend}>
                        <i className="icon fas fa-truck"/>
                    </div>;
                } else if (lagerbestandUeberschreiben == 1) {
                    hint = <div key="bestellartikel " className="hint-bestellartikel ok"
                                title={conf?.bestandAnzeige?.genug}>
                        <i className="icon fas fa-truck"/>
                    </div>;
                }
            } else {
                if (bestand <= this.props?.gering_ab && this.props?.gering_ab != null ||
                    (this.props?.gering_ab == null && this.props?.ausreichend_ab == null && bestand <= 0)) {
                    hint = <div key="bestellartikel " className="hint-bestellartikel wenig"
                                title={conf?.bestandAnzeige?.gering}>
                        <i className="icon fas fa-truck"/>
                    </div>;
                } else if (bestand > this.props?.gering_ab && bestand < this.props?.ausreichend_ab && this.props?.ausreichend_ab != null) {
                    hint = <div key="bestellartikel " className="hint-bestellartikel gering"
                                title={conf?.bestandAnzeige?.ausreichend}>
                        <i className="icon fas fa-truck"/>
                    </div>;
                } else {
                    hint = <div key="bestellartikel " className="hint-bestellartikel ok"
                                title={conf?.bestandAnzeige?.genug}>
                        <i className="icon fas fa-truck"/>
                    </div>;
                }
            }

            hints.push(
                hint
            );
        }


        if (this.props?.rabatt_fuer_umkarton && conf?.umkartonNew) {
            hints.push(
                <div key="rabattumkarton" className="hint-rabattumkarton"
                     title={'Bei Bestellungen von Originalkartons (Menge: ' + this.props?.umkartonmenge + ') gewähren wir eine Vergünstigung von '
                         + venditshop.helper.formatCurrency(this.props?.rabatt_fuer_umkarton)
                         + ' pro Verkaufseinheit'}>
                    <i className="icon fas fa-archive"/>
                </div>
            );
        }
        const rabatt = this?.state?.preise?.kdakt_result?.rabattkdaktion || null;
        const festabzug = (this?.state?.preise?.kdakt_result?.festabzug * this?.state?.preise?.picmenge) || null;
        const zusaetzliche_preisdarstellung = this?.state?.preise?.kdakt_result?.zusaetzliche_preisdarstellung;

        if (this.props.artikel && this.state?.preise?.originalpreis) {
            let angebot_hinweis_bezeichnung = null;
            if (meta?.login && meta?.licenseCache?.kdakt_rabatte_festpreise &&
                [venditshop.enums.zusaetzliche_preisdarstellung.RABATT_FESTABZUG,
                    venditshop.enums.zusaetzliche_preisdarstellung.ORIGINAL_PREIS_UND_RABATT_FESTABZUG]
                    .includes(zusaetzliche_preisdarstellung)) {
                if (rabatt) {
                    angebot_hinweis_bezeichnung = <>-{venditshop.helper.formatNumber(rabatt)}%</>;
                } else if (festabzug) {
                    angebot_hinweis_bezeichnung =
                        <>-{venditshop.helper.formatCurrency(festabzug)?.replace(' ', '')}</>;
                }
            }

            angebot_hinweis_bezeichnung = angebot_hinweis_bezeichnung || <><i>%</i>SALE</>;

            let restdauer = null;
            if (conf.anzeigeAktionsdauer && (this.props.gueltigbis || this.props.bisdatum)) {
                // const von = new Date(this.props.gueltigvon);
                const von = new Date();
                const bis = new Date((this.props.gueltigbis || this.props.bisdatum));
                const utc1 = Date.UTC(von.getFullYear(), von.getMonth(), von.getDate());
                const utc2 = Date.UTC(bis.getFullYear(), bis.getMonth(), bis.getDate());
                const diff = Math.floor((utc2 - utc1) / (1000 * 60 * 60 * 24));
                if (diff === 0) {
                    restdauer = ' (noch heute)';
                } else if (diff > 0 && diff < 100) {
                    restdauer = ' (noch ' + diff + ' ' + (diff === 1 ? 'Tag' : 'Tage') + ')';
                }
            }
            classes.push('origin');
            classes.push('promotion');
            if (restdauer) {
                hints.push(
                    <div key="dauer" className="hint-restdauer" title="Zeitlich befristeter Aktionspreis">
                        {restdauer}
                    </div>
                );
            }

            hints.unshift(<div key="sale" className="hint-sale" title="Zeitlich befristeter Aktionspreis">
                {angebot_hinweis_bezeichnung}
            </div>);
        } else if (this.props.boerse || this.props.mcboerse || (this.props.forcePromotion && this.state.preise)) {
            let restdauer = null;
            if (conf.anzeigeAktionsdauer && (this.props.gueltigbis || this.props.bisdatum)) {
                // const von = new Date(this.props.gueltigvon);
                const von = new Date();
                const bis = new Date((this.props.gueltigbis || this.props.bisdatum));
                const utc1 = Date.UTC(von.getFullYear(), von.getMonth(), von.getDate());
                const utc2 = Date.UTC(bis.getFullYear(), bis.getMonth(), bis.getDate());
                const diff = Math.floor((utc2 - utc1) / (1000 * 60 * 60 * 24));
                if (diff === 0) {
                    restdauer = ' (noch heute)';
                } else if (diff > 0 && diff < 100) {
                    restdauer = ` (noch ${diff} ${diff === 1 ? 'Tag' : 'Tage'})`;
                }
            }

            let bezeichnung;
            if (conf?.icon_boerse && !this.props.forcePromotion) {
                bezeichnung = <><i className={`icon ${conf.icon_boerse}`}/></>;
            } else {
                bezeichnung = <><i>%</i>SALE</>;
            }

            classes.push('promotion');
            if (restdauer) {
                hints.push(
                    <div key="dauer" className="hint-restdauer" title="Zeitlich befristeter Aktionspreis">
                        {restdauer}
                    </div>
                );
            }

            hints.unshift(<div key="sale" className="hint-sale" title="Zeitlich befristeter Aktionspreis">
                {bezeichnung}
            </div>);
        }

        if (this?.props?.hinweise?.length) {

            let hintEigen = this?.props?.hinweise?.map((hinweis, index) => {


                let title = hinweis?.beschreibung || '';

                let icon = '';
                switch (hinweis.icon) {
                    case 1:
                        icon = 'exclamation';
                        break;
                    case 2:
                        icon = 'thumbs-up';
                        break;
                    case 3:
                        icon = 'chart-line';
                        break;
                    case 4:
                        icon = 'highlighter';
                        break;
                    case 5:
                        icon = 'smile';
                        break;
                    case 6:
                        icon = 'plus';
                        break;
                    case 7:
                        icon = 'clock';
                        break;
                    case 8:
                        icon = 'bell';
                        break;
                    case 9:
                        icon = 'bullhorn';
                        break;
                    case 10:
                        icon = 'glasses';
                        break;
                    case 11:
                        icon = 'money-bill-wave';
                        break;
                    case 12:
                        icon = 'thumbstack';
                        break;
                    case 0:
                    default:
                        icon = '';
                        break;
                }
                return <div key={hinweis?.hinweis} className="hint-eigen"
                            title={title} style={{backgroundColor: hinweis?.farbe_hex}}>
                    {icon ? <i className={"icon fas fa-"+icon}/>:null}
                    {hinweis?.hinweis}
                </div>;
            });

            hints.push(...hintEigen);
        }


        if (hints && hints.length) {
            classes.push('hint');
            if (hints.length > 1) {
                classes.push('multi-hint');
            }
        }

        let loginHint;
        if (meta.login) {
            loginHint = <P4 className="text-hinweis">&nbsp;</P4>;
        } else {
            loginHint = <P3 className="text-hinweis">
                <a className="color-brand"
                   href={(props?.meta?.conf?.cssCompletePath ? props?.meta?.hostname : '') + '/login/'}>&nbsp;Login&nbsp;</a>für
                Individualpreis
            </P3>;
        }


        switch (this.props.size) {
            case 'big':
                classes.push('size-big');
                break;
            case 'galerie':
                classes.push('size-galerie');
                break;
            case 'liste':
                classes.push('size-liste');
                break;
            case 'tabelle':
                classes.push('size-tabelle');
                break;
            case 'ordsatz':
                classes.push('size-ordsatz');
                break;
            case 'default':
            default:
                classes.push('size-default');
                if (this.props.hideImg) {
                    classes.push('defaultNoImg');
                }
        }

        const produktBezeichnung = (this.props?.hideImg && artikelNummerText && mobile && conf?.artikelNrInKompaktAnischt
            ? artikelNummerText + ' | '
            : '') + venditshop.helper.fix_euro_sign(this.props.bezeichnung);
        let produktVerpackung = null;

        const props_verpackung = this.props.verpackung || false;

        if (props_verpackung) {
            produktVerpackung = <span className="verpackung">({props_verpackung})</span>;
        }

        let longname = produktBezeichnung.length >= 52;

        const bezeichnung = <h5
            className={'bezeichnung ' + (this?.props?.ordersatz_highlight ? 'ordersatz_highlight ' : ' ') + (longname
                ? 'longname'
                : '')}>
            <a href={linkDetails}>{produktBezeichnung}{produktVerpackung}</a>
        </h5>;

        if (this.props.size === 'ordsatz') {
            // Spezial-Ordersatz-Ansicht
            let verpackung = null;
            if (props_verpackung) {
                verpackung = <span className="verpackung" style={{
                    fontSize: '11px',
                    marginLeft: '0.625em',
                    whiteSpace: 'nowrap',
                    verticalAlign: 'bottom'
                }}>({props_verpackung})</span>;
            }
            const liefermenge1 = this.props.liefermenge1;
            const liefermenge2 = this.props.liefermenge2;
            const liefermenge3 = this.props.liefermenge3;
            const liefermenge4 = this.props.liefermenge4;
            const liefermenge5 = this.props.liefermenge5;
            const durchschnittsmenge = this.props.durchschnittsmenge;

            return <tr ref={this.ref}>
                {ordersatzspecialArtikel ? <td><a href={linkDetails}>{this.props.artikel}</a></td> : null}
                {ordersatzspecialBezeichnung ?
                    <td><a href={linkDetails}>{produktBezeichnung}{verpackung}</a></td> : null}
                <td className="right">{liefermenge5}</td>
                <td className="right">{liefermenge4}</td>
                <td className="right">{liefermenge3}</td>
                <td className="right">{liefermenge2}</td>
                <td className="right">{liefermenge1}</td>
                <td className="right">{durchschnittsmenge}</td>
                <td className="w200">
                    <ProductInput menge={0} defaultMengeNull productId={id} productType={productType}
                                  ordersatzSpezialansicht
                                  inactive={(!this.state.bestellbar || fehlerBeimPreisLaden)}
                                  listId={this.props?.listId}
                                  fakturiertext={this.props.fakturiertext || null}
                    />
                </td>
            </tr>;
        }

        let pMwst = null;
        let tablePreis = null;
        let tablePreisAltProduktkachel = null;
        let pOriginalpreis = null;
        let valKvp = null;
        let valVkp = null;
        let trVkpAlternativ = null;
        let valOriginalVkp = null;
        let valPreisauszeichnung = null;

        let vkpAlternativ = null;
        let vkpAlternativAuszeichnung = null;
        let stueckText = null;
        // const kdakt_uebersteuerung = this.state?.preise?.kdakt_result?.shop_preisauszeichnung_uebersteuern || false;
        let preisauszeichnung = this.props.preisauszeichnung;
        let preisdarstellung = this.props.preisdarstellung;
        const aktionsansicht = this?.props?.hrefPrefix?.endsWith('/promotion-of-the-week') || this?.props?.hrefPrefix?.endsWith('/promotion');
        if (meta?.licenseCache?.preisdarstellung_kdakt && aktionsansicht) {
            preisauszeichnung = this.state?.preise?.kdakt_result?.shop_preisauszeichnung;
            preisdarstellung = {
                vkp: !this.state?.preise?.kdakt_result?.shop_hide_ek,
                kvp: !this.state?.preise?.kdakt_result?.shop_hide_kvp
            };
        }
        // hier die Anpassung
        let boersenKVP = (this.state.onlyKvpAnzeigenBoersen && this.props?.boerse && meta.login);
        if (this.state.vkpAnzeigen || this.state.onlyKvpAnzeigen || boersenKVP) {
            // Falls das Kennzeichen "nur KVP Anzeigen" im Kudnenstamm gesetzt ist, wird automatisch der KVP mit dem VKP vertauscht.
            conf.swap_kvp_vkp = this.state.onlyKvpAnzeigen ? this.state.onlyKvpAnzeigen : conf?.swap_kvp_vkp;

            let swapkvp = conf.swap_kvp_vkp;

            if (!this.state.loaded || fehlerBeimPreisLaden) {
                if (meta?.licenseCache?.showAllePreise) {
                    trVkpAlternativ = <tr className="vkp-alternativ text-center">
                        {mobile ? <td className="text-preis-alternativ" colSpan="3">{'\xa0'}</td>
                            : <td className="text-preis-alternativ" colSpan="3">&nbsp;</td>}
                    </tr>;
                }
                tablePreis = <table className="preis-table">
                    <tbody>
                    <tr>
                        <td className="preis-alt" rowSpan="2">&nbsp;</td>
                        <td className="preis" rowSpan="2">&nbsp;</td>
                        <td className="text-euro">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="text-preis">&nbsp;</td>
                    </tr>
                    {trVkpAlternativ}
                    </tbody>
                </table>;
                pMwst = <P4 className="text-netto">&nbsp;</P4>;
                if (mobile) {
                    pOriginalpreis = <P2 className="preis-alt empty">&nbsp;</P2>;
                }
            } else {
                // Preise anzeigen und geladen
                if (preisauszeichnung === venditshop.enums.preisauszeichnung.STUECK) {

                    if (preisdarstellung) {
                        if (preisdarstellung.kvp) {
                            if (boersenKVP || conf?.swap_kvp_vkp) {
                                valKvp = venditshop.helper.formatNumber(this?.state?.preise?.kvp_stueck);
                            } else {
                                valKvp = venditshop.helper.formatCurrency(this?.state?.preise?.kvp_stueck);
                            }
                        } else {
                            valKvp = '\xa0';
                        }
                        if (preisdarstellung.vkp) {
                            if (boersenKVP || conf?.swap_kvp_vkp) {
                                valVkp = venditshop.helper.formatCurrency(this.state?.preise?.vkp_stueck, 3);
                            } else {
                                valVkp = venditshop.helper.formatNumber(this.state?.preise?.vkp_stueck, 3);
                            }

                            if (this?.state?.preise?.originalpreis_stueck) {
                                valOriginalVkp = (boersenKVP || conf?.swap_kvp_vkp
                                    ? 'EK '
                                    : '') + venditshop.helper.formatCurrency(this?.state?.preise?.originalpreis_stueck);
                            }
                            pMwst = <P4 className="text-netto">netto zzgl. gesetzlicher Mwst.</P4>;
                            valPreisauszeichnung = '€/Stk.';

                            if (meta?.licenseCache?.showAllePreise && this.state?.preise?.vkp !== this.state?.preise?.vkp_stueck) {
                                vkpAlternativ = venditshop.helper.formatCurrency(this.state?.preise?.vkp);
                                vkpAlternativAuszeichnung = 'Preis/Geb.:';
                            }
                        } else {
                            valVkp = '\xa0';
                            valOriginalVkp = null;
                            pMwst = <P4 className="text-netto">&nbsp;</P4>;
                            valPreisauszeichnung = '\xa0';
                            if (preisdarstellung.kvp) {
                                // wenn KVP und _NICHT_ VKP angezeigt werden soll, dann wird KVP an Position von VKP angezeigt

                                if (boersenKVP || conf?.swap_kvp_vkp) {
                                    valVkp = venditshop.helper.formatCurrency(this?.state?.preise?.kvp_stueck, 3);
                                } else {
                                    valVkp = venditshop.helper.formatNumber(this?.state?.preise?.kvp_stueck, 3);
                                }
                                valKvp = '\xa0';
                                valPreisauszeichnung = '€/KVP';
                            }
                        }
                    } else {
                        // valKvp = 'KVP ' + venditshop.helper.formatNumber(this?.state?.preise?.kvp_stueck, 3) + ' €';
                        valKvp =
                            venditshop.helper.formatNumber(this?.state?.preise?.kvp_stueck, 3) + (!(boersenKVP || conf?.swap_kvp_vkp)
                                ? ' €'
                                : '');
                        valVkp =
                            venditshop.helper.formatNumber(this.state?.preise?.vkp_stueck, 3) + (boersenKVP || conf?.swap_kvp_vkp
                                ? ' €'
                                : '');
                        if (this?.state?.preise?.originalpreis_stueck) {
                            valOriginalVkp = (boersenKVP || conf?.swap_kvp_vkp
                                ? 'EK '
                                : '') + venditshop.helper.formatCurrency(this?.state?.preise?.originalpreis_stueck);
                        }
                        pMwst = <P4 className="text-netto">netto zzgl. gesetzlicher Mwst.</P4>;
                        valPreisauszeichnung = '€/Stk.';


                        if (meta?.licenseCache?.showAllePreise && this.state?.preise?.vkp !== this.state?.preise?.vkp_stueck) {
                            vkpAlternativ = venditshop.helper.formatCurrency(this.state?.preise?.vkp);
                            vkpAlternativAuszeichnung = 'Preis/Geb.:';
                        }

                    }

                    if (venditshop.helper.formatNumber(this?.state?.preise?.originalpreis_stueck, 3) ===
                        venditshop.helper.formatNumber(this.state?.preise?.vkp_stueck, 3) ||
                        (meta?.licenseCache?.kdakt_rabatte_festpreise && zusaetzliche_preisdarstellung != null &&
                            [venditshop.enums.zusaetzliche_preisdarstellung.RABATT_FESTABZUG,
                                venditshop.enums.zusaetzliche_preisdarstellung.KEINE]
                                .includes(zusaetzliche_preisdarstellung))
                    ) {
                        valOriginalVkp = null;
                    }
                    if (valOriginalVkp) {
                        pOriginalpreis = <P2 className="preis-alt">{valOriginalVkp}</P2>;
                    } else {
                        pOriginalpreis = <P2 className="preis-alt empty">&nbsp;</P2>;
                        // pOriginalpreis = <P2/>;
                    }
                    if (meta?.licenseCache?.showAllePreise) {
                        // trVkpAlternativ = <tr className="vkp-alternativ text-center">
                        //     <td className="text-preis-alternativ" colSpan="3">&nbsp;</td>
                        // </tr>;
                        trVkpAlternativ = <tr className="vkp-alternativ text-center">
                            <td className="text-preis-alternativ" colSpan="3">
                                {vkpAlternativAuszeichnung}&nbsp;{vkpAlternativ}
                            </td>
                        </tr>;
                    }

                    if (meta?.licenseCache?.kdakt_rabatte_festpreise) {
                        trVkpAlternativ = <tr className="vkp-alternativ text-center">
                            <td className="text-preis-alternativ" colSpan="3">
                                {vkpAlternativAuszeichnung}&nbsp;{vkpAlternativ}
                            </td>
                        </tr>;
                    }

                    tablePreis = <table className="preis-table">
                        <tbody>
                        <tr>
                            {boersenKVP || conf?.swap_kvp_vkp && valKvp != '\xa0' ? <td className="preis-kvp">KVP</td> :
                                <td
                                    className="preis-alt"
                                    rowSpan="2">{valOriginalVkp}</td>}
                            <td className="preis" rowSpan="2">{conf?.swap_kvp_vkp ? valKvp : valVkp}</td>
                            <td className="text-euro"
                                title="Preis pro Stück">{((conf?.swap_kvp_vkp && valKvp != '\xa0') || (valVkp != '\xa0' && !conf?.swap_kvp_vkp))
                                ? valPreisauszeichnung
                                : null}</td>
                        </tr>
                        <tr>
                            {boersenKVP || conf?.swap_kvp_vkp && valKvp != '\xa0'
                                ? <td className="preis-alt">{valOriginalVkp}</td>
                                : null}
                            <td className="text-preis">{boersenKVP || conf?.swap_kvp_vkp
                                ? ((valVkp && valVkp !== '\xa0' && !this.state.onlyKvpAnzeigen) && 'EK ' + valVkp)
                                : (valKvp && valKvp !== '\xa0') && ('KVP ' + valKvp)}</td>
                        </tr>
                        {!this.state.onlyKvpAnzeigen && trVkpAlternativ}
                        </tbody>
                    </table>;

                    if (conf?.altProduktkachel) {
                        stueckText = 'Stück';
                        tablePreisAltProduktkachel = <table className="preis-table altKachel">
                            <tbody>
                            <tr>
                                <td className="verpackungKVP">
                                    {conf?.altKachelVerpackung ? stueckText : this?.props?.verpackung}
                                </td>
                                <td rowSpan="2" className="preis">
                                    {!this.state.onlyKvpAnzeigen ? venditshop.helper.formatCurrency(valVkp) : null}
                                </td>
                            </tr>
                            <tr>
                                <td className="altKVP">
                                    {!this.props?.mcboerse ? "KVP: " + valKvp : null}
                                </td>
                            </tr>
                            </tbody>
                        </table>;
                    }

                } else if (preisauszeichnung === venditshop.enums.preisauszeichnung.GEBINDE) {
                    if (preisdarstellung) {
                        if (preisdarstellung.kvp) {
                            if (boersenKVP || conf?.swap_kvp_vkp) {
                                valKvp = venditshop.helper.formatNumber(this?.state?.preise?.kvp);
                            } else {
                                valKvp = venditshop.helper.formatCurrency(this?.state?.preise?.kvp);
                            }
                        } else {
                            valKvp = '\xa0';
                        }

                        if (preisdarstellung.vkp) {
                            valVkp = venditshop.helper.formatNumber(this.state?.preise?.vkp,
                              (conf?.preisedreistellig ? 3 : 2));

                            if (boersenKVP || conf?.swap_kvp_vkp) {
                                valVkp = venditshop.helper.formatCurrency(this.state?.preise?.vkp,
                                  (conf?.preisedreistellig ? 3 : 2));
                            } else {
                                valVkp = venditshop.helper.formatNumber(this.state?.preise?.vkp,
                                  (conf?.preisedreistellig ? 3 : 2));
                            }
                            if (this?.state?.preise?.originalpreis) {
                                valOriginalVkp =
                                    (boersenKVP || conf?.swap_kvp_vkp
                                        ? 'EK '
                                        : '') + venditshop.helper.formatCurrency(this?.state?.preise?.originalpreis);
                            }
                            pMwst = <P4 className="text-netto">netto zzgl. gesetzlicher Mwst.</P4>;
                            valPreisauszeichnung = '€/Geb.';

                            if (meta?.licenseCache?.showAllePreise && this.state?.preise?.vkp !== this.state?.preise?.vkp_stueck) {
                                vkpAlternativ = venditshop.helper.formatNumber(this.state?.preise?.vkp_stueck, 3) + ' €';
                                vkpAlternativAuszeichnung = 'Preis/Stk.:';
                            }

                        } else {
                            valVkp = '\xa0';
                            valOriginalVkp = null;
                            pMwst = <P4 className="text-netto">&nbsp;</P4>;
                            valPreisauszeichnung = '\xa0';
                            if (preisdarstellung.kvp) {
                                // wenn KVP und _NICHT_ VKP angezeigt werden soll, dann wird KVP an Position von VKP angezeigt
                                valVkp = venditshop.helper.formatNumber(this?.state?.preise?.kvp);
                                valKvp = '\xa0';
                                valPreisauszeichnung = '€/KVP';
                            }
                        }
                    } else {
                        valKvp = 'KVP ' + venditshop.helper.formatCurrency(this?.state?.preise?.kvp);
                        valVkp = venditshop.helper.formatNumber(this.state?.preise?.vkp);
                        if (this?.state?.preise?.originalpreis) {
                            valOriginalVkp =
                                (boersenKVP || conf?.swap_kvp_vkp
                                    ? 'EK '
                                    : '') + venditshop.helper.formatCurrency(this?.state?.preise?.originalpreis);
                        }
                        pMwst = <P4 className="text-netto">netto zzgl. gesetzlicher Mwst.</P4>;
                        valPreisauszeichnung = '€/Geb.';

                        // console.log('tes2');
                        if (meta?.licenseCache?.showAllePreise && this.state?.preise?.vkp !== this.state?.preise?.vkp_stueck) {
                            vkpAlternativ = venditshop.helper.formatNumber(this.state?.preise?.vkp_stueck, 3) + ' €';
                            vkpAlternativAuszeichnung = 'Preis/Stk.:';
                        }
                    }
                    if (venditshop.helper.formatNumber(this?.state?.preise?.originalpreis) ===
                        venditshop.helper.formatNumber(this.state?.preise?.vkp) ||
                        ((meta?.licenseCache?.kdakt_rabatte_festpreise && zusaetzliche_preisdarstellung != null &&
                            [venditshop.enums.zusaetzliche_preisdarstellung.RABATT_FESTABZUG,
                                venditshop.enums.zusaetzliche_preisdarstellung.KEINE]
                                .includes(zusaetzliche_preisdarstellung)))
                    ) {
                        valOriginalVkp = null;
                    }
                    if (valOriginalVkp) {
                        pOriginalpreis = <P2 className="preis-alt">{valOriginalVkp}</P2>;
                    } else {
                        pOriginalpreis = <P2 className="preis-alt empty">&nbsp;</P2>;
                        // pOriginalpreis = <P2/>;
                    }
                    if (meta?.licenseCache?.showAllePreise) {
                        trVkpAlternativ = <tr className="vkp-alternativ text-center">
                            <td className="text-preis-alternativ" colSpan="3">
                                {vkpAlternativAuszeichnung}&nbsp;{vkpAlternativ}
                            </td>
                        </tr>;
                    }
                    tablePreis = <table className="preis-table">
                        <tbody>
                        <tr>
                            {boersenKVP || conf?.swap_kvp_vkp && valKvp != '\xa0' ? <td className="preis-kvp">KVP</td> :
                                <td
                                    className="preis-alt" rowSpan="2">{valOriginalVkp}</td>}
                            <td className="preis" rowSpan="2">{boersenKVP || conf?.swap_kvp_vkp ? valKvp : valVkp}</td>
                            <td className="text-euro"
                                title="Preis pro Gebinde">{((boersenKVP || conf?.swap_kvp_vkp && valKvp != '\xa0') || (valVkp != '\xa0' && !(boersenKVP || conf?.swap_kvp_vkp)))
                                ? valPreisauszeichnung
                                : null}</td>
                        </tr>
                        <tr>
                            {boersenKVP || conf?.swap_kvp_vkp && valKvp != '\xa0'
                                ? <td className="preis-alt">{valOriginalVkp}</td>
                                : null}
                            <td className="text-preis">{boersenKVP || conf?.swap_kvp_vkp
                                ? ((valVkp && valVkp !==
                                    '\xa0' && !this.state.onlyKvpAnzeigen) && 'EK ' + valVkp)
                                : (valKvp && valKvp !== '\xa0') && ('KVP ' + valKvp)}</td>
                        </tr>
                        {!this.state.onlyKvpAnzeigen && trVkpAlternativ}
                        </tbody>
                    </table>;

                    if (conf?.altProduktkachel) {
                        stueckText = 'Gebinde';
                        tablePreisAltProduktkachel = <table className="preis-table altKachel">
                            <tbody>
                            <tr>
                                <td className="verpackungKVP">
                                    {conf?.altKachelVerpackung ? stueckText : this?.props?.verpackung}
                                </td>
                                <td rowSpan="2" className="preis" title="Preis pro Gebinde">
                                    {!this.state.onlyKvpAnzeigen ?
                                        venditshop.helper.formatCurrency(this?.state?.preise?.vkp) : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="altKVP" title="KVP pro Gebinde">
                                    {!this.props?.mcboerse ? "KVP: " + venditshop.helper.formatCurrency(this?.state?.preise?.kvp) : null}
                                </td>
                            </tr>
                            </tbody>
                        </table>;
                    }
                } else {
                    // Boerse
                    pOriginalpreis = <P2 className="preis-alt">
                        {venditshop.helper.formatCurrency(this?.state?.preise?.originalpreis)}
                    </P2>;
                    if (meta?.licenseCache?.showAllePreise) {
                        // console.log('2');
                        trVkpAlternativ = <tr className="vkp-alternativ text-center">
                            <td className="text-preis-alternativ" colSpan="3">&nbsp;</td>
                        </tr>;
                    }
                    pMwst = <P4 className="text-netto">netto zzgl. gesetzlicher Mwst.</P4>;

                    tablePreis = <table className="preis-table">
                        <tbody>
                        <tr>
                            {(conf?.swap_kvp_vkp || boersenKVP) && valKvp != '\xa0' ?
                                <td className="preis-kvp">KVP</td> : <td
                                    className="preis-alt"
                                    rowSpan="2">{venditshop.helper.formatNumber(this?.state?.preise?.originalpreis)}</td>}
                            <td className="preis" rowSpan="2"
                                title={boersenKVP || conf?.swap_kvp_vkp ? 'KVP' : ''}>{boersenKVP || conf?.swap_kvp_vkp
                                ? venditshop.helper.formatNumber(this?.state?.preise?.kvp)
                                : !this.state.onlyKvpAnzeigen && venditshop.helper.formatNumber(this.state?.preise?.vkp)}</td>
                            <td className="text-euro" title="Preis pro Aktionspaket">€/Akt.</td>
                        </tr>
                        <tr>
                            {conf?.swap_kvp_vkp && valKvp != '\xa0' && !boersenKVP
                                ? <td
                                    className="preis-alt">{venditshop.helper.formatNumber(this?.state?.preise?.originalpreis)}</td>
                                : null}
                            <td className="text-preis">{
                                conf?.swap_kvp_vkp
                                    ? !this.state.onlyKvpAnzeigen && 'EK ' + venditshop.helper.formatCurrency(this.state?.preise?.vkp)
                                    : (!boersenKVP ?
                                        'KVP ' + venditshop.helper.formatCurrency(this?.state?.preise?.kvp) : '')
                            }</td>
                        </tr>
                        {!this.state.onlyKvpAnzeigen && trVkpAlternativ}
                        </tbody>
                    </table>;


                    if (dontShow) {
                        tablePreis = <table className="preis-table">
                            <tbody>
                            <tr>
                                <td rowSpan="2">&nbsp;</td>
                                <td className="preis" rowSpan="2">&nbsp;</td>
                                <td className="text-euro">&nbsp;</td>
                            </tr>
                            <tr>
                                <td className="text-preis">&nbsp;</td>
                            </tr>
                            {trVkpAlternativ}
                            </tbody>
                        </table>;
                        pMwst = <P4 className="text-netto">&nbsp;</P4>;
                        pOriginalpreis = null;
                        tablePreisAltProduktkachel = null;
                    }


                    if (conf?.altProduktkachel) {
                        stueckText = '';
                        tablePreisAltProduktkachel = <table className="preis-table altKachel">
                            <tbody>
                            <tr>
                                <td className="verpackungKVP">
                                    &nbsp;
                                </td>
                                <td rowSpan="2" className="preis">
                                    {!this.state.onlyKvpAnzeigen ?
                                        venditshop.helper.formatCurrency(this?.state?.preise?.vkp) : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="altKVP">
                                    {!this.props?.mcboerse ? "KVP: " + venditshop.helper.formatCurrency(this?.state?.preise?.kvp) : null}
                                </td>
                            </tr>
                            </tbody>
                        </table>;
                    }
                }
            }
        } else {
            // keine Preise
        }
        const onclick = async () => {
            await store.set('distmodal', true);
        };

        let img = null;
        if (!this.props.hideImg) {
            img = <div className="img">
                <a href={linkDetails} onClick={onclick}><img alt={produktBezeichnung} src={bild}/></a>
            </div>;
        }

        if (this.props?.listId) {
            classes.push('ordsatz');
        }

        if (conf?.altProduktkachel) {
            classes.push('altKachel');
        }

        if (this.props?.hausmesse) {
            classes.push('hausmesse');
        }


        if (meta?.licenseCache?.individualpreis && this.props?.individualpreis && !meta?.login) {
            loginHint = <P3 className="text-hinweis">
                Individueller Preis auf Anfrage</P3>;
        }

        let preise = <>{kampagneShopSpezialGrund}
            {pOriginalpreis}
            {tablePreis}
            {tablePreisAltProduktkachel}
            {pMwst}
            {loginHint}</>;


        if (this.props?.listId && medium) {
            preise = <div className="preiswrapper">
                {kampagneShopSpezialGrund}
                {pOriginalpreis}
                {tablePreis}
                {tablePreisAltProduktkachel}
                {pMwst}
                {loginHint}</div>;
        }

        let individualpreis;
        if (meta?.licenseCache?.individualpreis && this.props?.individualpreis && meta?.login) {
            preise = null;
            individualpreis = <p className="individualPreis">
                Individueller Preis<br/>auf Anfrage
            </p>;
        }

        let aufpreisBeiAnbruch;

        if (this.props?.anbruch_aufschlag_kz && this.props?.meta?.licenseCache?.aufpreisBeiAnbruch
            && meta.login
            && this.props?.gebindeeinheit && this.props?.gebindeeinheit != this.props?.verkaufseinheit
            && this?.state?.preisBeiAnbruch) {

            let preisProKarton = this.state.preisBeiAnbruch.vkp_stueck *
                this.props?.picmenge_verkauf;

            //Preisdarstelung stück
            if (preisauszeichnung === venditshop.enums.preisauszeichnung.STUECK) {
                preisProKarton = this.state.preisBeiAnbruch.vkp_stueck;
            }

            aufpreisBeiAnbruch =
                <P3 className={'aufpreisBeiAnbruch'}>Bei Abnahme im Karton: {venditshop.helper.formatCurrency(
                    preisProKarton)}</P3>;
        } else if (this.props?.meta?.conf?.fakturiertextProdukachel
            && this.props?.fakturiertext
            && !this.props?.fakturierstop && meta.login) {

            aufpreisBeiAnbruch =
                <P3 className={'fakturiertext'} title={this.props?.fakturiertext}>{this.props?.fakturiertext}</P3>;

        } else {
            aufpreisBeiAnbruch = <P3 className={'aufpreisBeiAnbruch'}>&nbsp;</P3>;
        }

        let erlaubteDistMenge = null;

        if (meta?.licenseCache?.boersenDist) {
            erlaubteDistMenge = (this?.props?.distributionsmeng - (this?.props?.bereitsbestelltedistmenge || 0))
        }

        if (meta?.licenseCache?.maxmengeBoerse && this?.props?.max_menge) {
            erlaubteDistMenge = this?.props?.max_menge - (this?.props?.anzahlbestellungen || 0);
            if (!meta?.login) {
                dontShow = true;
            }
        }


        let styles={};


        return <div ref={this.ref} className={classes.join(' ')} style={{ color: (this?.props?.font_color == 1 ? 'white': 'black') }}
        style={styles}>
            <div className="hint-wrap">{hints}</div>
            {img}
            {bezeichnung}
            {anzeigeNummer}
            {/*{conf?.altProduktkachel ? <h6 className={'originalPreisAltkachel'}>{venditshop.helper.formatCurrency(this?.state?.preise?.originalpreis)}</h6>: null}*/}
            {!(this.props?.listId && medium) ? preise : null}
            {aufpreisBeiAnbruch}
            {individualpreis}
            <ProductInput
                ref={this.input_ref}
                dontShow={dontShow}
                vertriebsaktion={this.props?.vertriebsaktion}
                hausmesse={this?.props?.hausmesse}
                liefertage={this?.props?.liefertage}
                productId={id} productType={productType}
                anbruch={!!this.props.anbruch || false}
                verkaufseinheit={this.props.verkaufseinheit} basiseinheit={this.props.basiseinheit}
                picmengeverkauf={this.props.picmenge_verkauf}
                reloadList={this.props?.reloadList}
                inactive={(!this.state.bestellbar || fehlerBeimPreisLaden)} changeCallback={this.loadPreise}
                fakturiertext={this.props.fakturiertext || null}
                menge={this.props.menge}
                listId={this.props?.listId}
                bestellartikel={this.props.bestellartikel}
                untergrenze={this.props.untergrenze}
                obergrenze={this.props.obergrenze}
                nur_gebinde={this?.props?.nur_gebinde && !this.props.anbruch_zulassen}
                umpack={this.props.umpack}
                umkartonmenge={this.props.umkartonmenge}
                rabatt_fuer_umkarton={this.props?.rabatt_fuer_umkarton}
                umkartonNew={conf?.umkartonNew}
                minbestellmenge={this.props.minbestellmenge}
                erlaubteDistMenge={erlaubteDistMenge}
                hervorheben={this?.props?.hervorheben}
                background_color_hex={this?.props?.background_color_hex}
                font_color={this?.props?.font_color}
            />
            {this.props?.listId && medium ? preise : null}
            {mobile ? null : <a className="link-details" href={linkDetails} onClick={onclick}>Produktdetails<i
                className="icon fas fa-chevron-circle-right" onClick={onclick}/></a>}
        </div>;
    }
}

export default ReactRedux.connect(
    (state, ownProps) => {
        let menge = ownProps.menge || (ownProps?.nur_gebinde && ownProps?.picmengeverkauf === 1 ? ownProps.umpack : 1);
        const productType = ownProps.artikel ? 'a' : 'b';
        const productId = ownProps.artikel || ownProps.boerse;
        if (state.cart[productType] && state.cart[productType][productId]) {
            menge = state.cart[productType][productId].menge;
        } else if (ownProps?.aktionsmengen?.length &&
            (!!(state.meta?.vkpAnzeigen || (state.meta.aktionspreiseAnzeigen && ownProps?.forcePromotion)))) {
            menge = Math.max(...ownProps.aktionsmengen);
        }
        if (ownProps?.listId) {
            return {meta: state.meta, mobile: state.mobile.isMobile, medium: state.mobileMedium.isMedium};
        } else {
            return {menge, meta: state.meta, mobile: state.mobile.isMobile, medium: state.mobileMedium.isMedium};
        }
    }, (dispatch) => ({
        changeCart: (typ, id, menge, override, url) => dispatch(updateShoppingCart(typ, id, menge, override, null, null, url)),
        changeLoading: (loading) => {
            dispatch(receiveLoadingUpdate(loading));
        }
    }), null, {forwardRef: true})(Product);
